import React, { forwardRef, useEffect, useRef } from 'react';
import { trackSectionView, trackTimeSpentOnSection } from '../Helper/Analytics';
import SectionNames from '../Helper/SectionName';

/**
 * Reusable Section component with analytics tracking.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - Content to render inside the section.
 * @param {string} props.id - ID of the section for tracking.
 * @param {string} props.sectionName - Name of the section for tracking.
 * @param {React.RefObject} props.ref - Ref to the section element.
 * @returns {JSX.Element} - Rendered component.
 */
const SectionWithAnalytics = forwardRef(({ children, id, ...rest }, ref) => {
    const internalRef = useRef(null);
    const sectionRef = ref ?? internalRef;
    const sectionName = SectionNames[id] || id;

    useEffect(() => {

        const cleanupViewTracking = trackSectionView(sectionRef, sectionName);
        const cleanupTimeTracking = trackTimeSpentOnSection(sectionRef, sectionName);

        return () => {
            cleanupViewTracking();
            cleanupTimeTracking();
        };
    }, [sectionName]);

    return (
        <section id={id} ref={sectionRef} {...rest}>
            {children}
        </section>
    );
});

export default SectionWithAnalytics;
